import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { topCustomerReportRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE];

const topCustomerReportRouteMetadata: IRouteMetadataObj<
  typeof topCustomerReportRoutesObj
> = {
  list: {
    title: "reportManagement.index.title",
    description: "empty",
    lazy: () => import("@pages/reportManagement/topCustomerReport/table/page"),
    mode: "index",
    type: "main",
    icon: "FileChartLine",
    breadcrumbs: [],
    permission,
  },
};

export const topCustomerReportRoutes = createRoute<
  typeof topCustomerReportRoutesObj
>(topCustomerReportRoutesObj, topCustomerReportRouteMetadata);
